<template>
  <div v-if="showForm">
    <ValidationObserver ref="changePasswordFormValidator">
      <form
        @submit.prevent="submitChangePassword"
        data-qa="por-change-password--form"
      >
        <Input
          id="old-password"
          :input-model.sync="oldPassword"
          placeholder-text="••••••••"
          :label-text="$t('changePasswordForm_current_text')"
          input-type="password"
          data-qa="por-change-password--old-password-input" />
        <Password
          id="password"
          class="mt-3"
          :input-model.sync="newPassword"
          :label-text="$t('common_newPassword_text')"
          placeholder-text="••••••••"
          :error-text="`${$t('common_validPassword_text')}.`"
          data-qa="por-change-password--new-password-input" />
        <b-button
          size="is-medium"
          type="is-primary"
          class="mt-6"
          expanded
          :disabled="isSubmitting"
          :loading="isSubmitting"
          tag="input"
          native-type="submit"
          :value="$t('changePasswordForm_change_text')"
          data-qa="por-change-password--submit" />
      </form>
    </ValidationObserver>
  </div>
  <div v-else>
    <b-button
      @click.prevent="redirectToAccount"
      size="is-medium"
      type="is-primary"
      expanded
      :disabled="isSubmitting"
      :loading="isSubmitting"
      tag="input"
      :value="$t('changePasswordForm_back_button')"
      data-qa="por-change-password--redirect-link" />
  </div>
</template>

<script>
import { Auth } from '@aws-amplify/auth'

import router from '@/router'

import Input from '@/components/inputs/input'
import Password from '@/components/inputs/password'

import { redirect } from '@/services/redirect'
import { errorMessageMapping } from '@/helpers/message-mapping'
import { track } from '@/services/tracking'
import trackErrors from '@/helpers/track-errors'
import { getUrlLocale } from '@/helpers/url'

export default {
  name: 'ChangePasswordForm',
  components: {
    Input,
    Password
  },
  data () {
    return {
      showForm: true,
      cognitoUser: null,
      oldPassword: '',
      newPassword: '',
      submitStatus: null
    }
  },
  methods: {
    async submitChangePassword () {
      track({ name: 'button tap', params: { module: 'change password', description: 'change password button' } })

      this.submitStatus = 'PENDING'

      this.$refs.changePasswordFormValidator.validate().then(async success => {
        if (!success) {
          this.submitStatus = 'ERROR'
          trackErrors(this.$refs.forgotPasswordFormValidator, 'change password')
          return
        }

        try {
          await Auth.changePassword(this.cognitoUser, this.oldPassword, this.newPassword)

          this.$store.dispatch('site/setMessage', { message: 'changePassword_reset_text', type: 'success' })

          this.showForm = false
          track({ name: 'forgot password success', params: { module: 'change password' } })
        } catch (error) {
          let errorMessage = errorMessageMapping(error.message)

          this.$store.dispatch('site/setMessage', { message: errorMessage, type: 'danger' })
          track({ name: 'error', params: { module: 'forgot password', error_message: errorMessage } })
        }

        this.submitStatus = null
      })
    },
    redirectToAccount () {
      redirect()
    }
  },
  async created () {
    const urlLocale = getUrlLocale() ? `/${getUrlLocale()}` : ''
    const redirectUrl = `${window.location.origin}${urlLocale}/auth/change-password/`

    try {
      this.cognitoUser = await Auth.currentAuthenticatedUser()
    } catch (error) {
      router.push({ name: 'login', query: { redirect: redirectUrl } })
    }

    if (!this.cognitoUser) {
      router.push({ name: 'login', query: { redirect: redirectUrl } })
    }
  }
}
</script>
<style lang="scss" scoped>
</style>
